import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

// Opens the app-modal immediately with a loader, then lets turbo-stream replace content.
// Usage:
//   link_to "Edit", path, data: { turbo_stream: true, controller: "modal", action: "click->modal#open" }
export default class extends Controller {
  open() {
    const modalElement = document.getElementById('app-modal')
    const modalContent = document.getElementById('app-modal-content')
    const loaderTemplate = document.getElementById('app-modal-loader')

    // Reset to loader state
    modalContent.innerHTML = ''
    modalContent.appendChild(loaderTemplate.content.cloneNode(true))

    const modal = Modal.getOrCreateInstance(modalElement)
    modal.show()
  }

  static close() {
    const modalElement = document.getElementById('app-modal')
    const modal = Modal.getInstance(modalElement)
    if (modal) modal.hide()
  }
}
